const unresolvedPatterns = [
  /\[\s*TO\s+BE\s+DETERMINED\s*\]/i,
  /\{\{[^}]+\}\}/,
  />\s*(?:undefined|null|NaN)\s*</i
];

const unresolvedContractTokens = value => {
  const text = String(value || "");
  return unresolvedPatterns
    .filter(pattern => pattern.test(text))
    .map(pattern => pattern.source);
};

const isContractResolved = value =>
  Boolean(String(value || "").trim()) &&
  unresolvedContractTokens(value).length === 0;

module.exports = {
  isContractResolved,
  unresolvedContractTokens
};
